export const sessionStatusMapping = {
  'working': 'Conectado',
  'starting': 'Iniciando',
  'created': 'Criado',
  'scan_qr_code': 'Aguardando QR Code',
  'stopped': 'Parado',
  'restarting': 'Reiniciando',
  'failed': 'Erro',
} as const;

export function normalizeStatus(status: string | undefined): string {
  return (status || '').toLowerCase();
}

export function getQrCodeUrl(url: string): string {
  return url || '';
}